import React from 'react';
import classNames from 'classnames';

import styles from './ColumnLayout.module.scss';

export default function ColumnLayout({ children, className }) {
  return (
    <div className={classNames(styles.ColumnLayout, className)}>{children}</div>
  );
}

ColumnLayout.Column = function Column({ children, className }) {
  return <div className={classNames(styles.Column, className)}>{children}</div>;
};
